import { useQuery } from '@tanstack/react-query'

import { API_URL } from '../../constants'
import { useUpFetch } from '../../utils'

export const getCurrencies = () => {
  const upFetch = useUpFetch()

  return useQuery({
    queryFn: async () =>
      upFetch<{ data: Array<{ alias: string; id: number; title: string }> }>(
        `${API_URL}currency-type`,
      ),
    queryKey: ['currencies'],
  })
}
